import React from 'react';

import { unmountChildComponents } from 'helpers/react_on_rails';

// When a frame is rendered, it may be replacing React components, which must be unmounted to
// prevent memory leaks
export function handleBeforeFrameRender(event) {
  if (document.getElementById(event.target.id)) {
    unmountChildComponents(event.target);
  }
}

// Ditto to handleBeforeFrameRender for streams, but only for destructive actions
export function handleBeforeStreamRender(event) {
  const { action } = event.detail.newStream;
  if (action === 'remove' || action === 'replace' || action === 'update') {
    unmountChildComponents(findStreamTarget(event.detail.newStream));
  }
}

function findStreamTarget(stream) {
  return document.querySelector(`#${stream.target}`);
}

// If you are rendering React content inside of a Turbo frame on initial page load, and that Turbo
// frame can load other content that does not render any components, then any components outside of
// that Turbo frame will be unmounted if the frame's initial component was the first in the DOM.
// HACK: So, use an empty component outside of such a frame to ensure that won't happen.
export function MetadataPlaceholder() {
  return <div/>;
}
